module.exports = __webpack_public_path__ + "bc8f11dc3dbee46d378d2883e2f0048a.fbx";